import { reactive } from "vue"
import { PublicClient } from "../../entities/NSwagGenerated"

const environmentName = import.meta.env.VITE_ENVIRONMENT_NAME?.toString().trim() || "Unknown"
const fallbackColors = {
	backgroundColor: "#5093ff",
	textColor: "white",
}

const environmentSettingsState = reactive({
	backgroundColor: fallbackColors.backgroundColor,
	textColor: fallbackColors.textColor,
	environmentName,
})

let loadEnvironmentBadgePromise: Promise<void> | null = null

export async function loadEnvironmentBadge() {
	if (loadEnvironmentBadgePromise) {
		return loadEnvironmentBadgePromise
	}

	loadEnvironmentBadgePromise = (async () => {
		try {
			const client = new PublicClient(useAPIurl())
			const badge = await client.environmentBadge()
			environmentSettingsState.backgroundColor = badge?.backgroundColor || fallbackColors.backgroundColor
			environmentSettingsState.textColor = badge?.textColor || fallbackColors.textColor
		} catch {
			environmentSettingsState.backgroundColor = fallbackColors.backgroundColor
			environmentSettingsState.textColor = fallbackColors.textColor
		} finally {
			loadEnvironmentBadgePromise = null
		}
	})()

	return loadEnvironmentBadgePromise
}

export function useAPIurl() {
	return import.meta.env.VITE_API_URL?.toString() || ""
}

export function useEnvironmentSettings() {
	return environmentSettingsState
}
